module.exports = __webpack_public_path__ + "static/img/zh-Hant.66e8317.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/zh-Hant.png
// module id = ijpo
// module chunks = 1